import { Currency } from '@/core/currency/interfaces';

const BAM: Currency = {
    name: 'Bosnia and Herzegovina Convertible Mark',
    demonym: 'Bosnia-Herzegovina',
    majorSingle: 'Convertible Mark',
    majorPlural: 'Marks',
    codeNumeric: '977',
    symbol: 'KM',
    symbolNative: 'КМ',
    minorSingle: 'Fening',
    minorPlural: 'Fening',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BAM',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BAM;
